'use client'

import { Services } from '@/screens/Services'

import { TServiceItem } from '@/shared/types/deprecated-types'

type Props = {
	services: TServiceItem[]
}

const ServicesPageContent = ({ services }: { services: TServiceItem[] }) => {
	return <Services services={services} />
}

export function ServicesClient({ services }: Props) {
	return <ServicesPageContent services={services} />
}
